import { useDispatchBaseEvent, useSubscribeToBaseEvent } from "../useDispatchBaseEvent";

export const SET_AS_BACKGROUND_IMAGE_EVENT_NAME = "useSetAsBackgroundImageEvent";

type SetAsBackgroundImageEvent = {
  type: typeof SET_AS_BACKGROUND_IMAGE_EVENT_NAME;
  payload: void;
};

export function useDispatchSetAsBackgroundImageEvent() {
  return useDispatchBaseEvent<SetAsBackgroundImageEvent>(SET_AS_BACKGROUND_IMAGE_EVENT_NAME);
}

export function useSubscribeToSetAsBackgroundImageEvent(
  handler: (payload: SetAsBackgroundImageEvent["payload"]) => void
) {
  useSubscribeToBaseEvent<SetAsBackgroundImageEvent>(SET_AS_BACKGROUND_IMAGE_EVENT_NAME, handler);
}
